
//api
const config = {
    apiBaseUrl: 'https://fitness-junkies.herokuapp.com/api',
  };
  
  export default config